import { intervalToDuration } from "date-fns";

export function formatDate(dob: string | Date): string {
    const date = new Date(dob);
    const options: Intl.DateTimeFormatOptions = {
        year: "numeric",
        month: "long",
        day: "2-digit",
    };

    return date.toLocaleDateString("en-US", options);
}

export function formatDateForEmail(date: Date | string) {
    const now = new Date().getTime();
    const inputDate = new Date(date).getTime();
    const diffInMs = now - inputDate;
    const diffInSeconds = Math.floor(diffInMs / 1000);
    const diffInMinutes = Math.floor(diffInSeconds / 60);
    const diffInHours = Math.floor(diffInMinutes / 60);
    const diffInDays = Math.floor(diffInHours / 24);
    const diffInMonths = Math.floor(diffInDays / 30);

    if (diffInSeconds < 60) {
        return "just now";
    } else if (diffInMinutes < 60) {
        return `${diffInMinutes} minute${diffInMinutes > 1 ? "s" : ""} ago`;
    } else if (diffInHours < 24) {
        return `${diffInHours} hour${diffInHours > 1 ? "s" : ""} ago`;
    } else if (diffInDays === 1) {
        return "yesterday";
    } else if (diffInDays <= 10) {
        return `${diffInDays} day${diffInDays > 1 ? "s" : ""} ago`;
    } else if (diffInMonths < 1) {
        return `${diffInDays} days ago`;
    } else if (diffInMonths === 1) {
        return "1 month ago";
    } else {
        return `${diffInMonths} months ago`;
    }
}

export const formattedStartDate = (startDate: Date | string) =>
    new Date(startDate).toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        // day: "numeric",
    });

export const formattedEndDate = (endDate: Date | string | undefined) =>
    endDate
        ? new Date(endDate).toLocaleDateString("en-US", {
              year: "numeric",
              month: "long",
              // day: "numeric",
          })
        : "Present";

export const formatDateForInput = (date: Date | string) => {
    const d = new Date(date);
    return d.toISOString().split("T")[0];
};

export function getTotalDuration(startDate: string, endDate?: string | null) {
    endDate = endDate ? endDate : new Date().toISOString().split("T")[0];

    const duration = intervalToDuration({
        start: new Date(startDate),
        end: endDate ? new Date(endDate) : new Date(),
    });

    const { years = 0, months = 0 } = duration;

    const result = [];
    if (years > 0) result.push(`${years} Year${years > 1 ? "s" : ""}`);
    if (months > 0) result.push(`${months} Month${months > 1 ? "s" : ""}`);

    return result.join(" ");
}
